var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13298",
    "data-name": "Group 13298",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.988,
    height: 14.988,
    viewBox: "0 0 14.988 14.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24197",
    "data-name": "Path 24197",
    d: "M0,0H14.988V14.988H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24198",
    "data-name": "Path 24198",
    d: "M2,3.625A.625.625,0,0,1,2.625,3H13.866a.625.625,0,0,1,.625.625V7.059a1.561,1.561,0,0,0,0,3.123v3.435a.625.625,0,0,1-.625.625H2.625A.625.625,0,0,1,2,13.617Zm3.8,9.368a.937.937,0,0,1,1.767,0h5.674V11.139a2.81,2.81,0,0,1,0-5.036V4.249H7.568a.937.937,0,0,1-1.767,0H3.249v8.743Zm.884-5a.937.937,0,1,1,.937-.937A.937.937,0,0,1,6.684,8Zm0,3.123a.937.937,0,1,1,.937-.937A.937.937,0,0,1,6.684,11.119Z",
    transform: "translate(-0.751 -1.126)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon-icon.a9ffaa016d58681cd3737fd2c1119e94.svg";
export { ForwardRef as ReactComponent };